import { httpClient } from './httpClient';

const base = '/api/cargos-adicionales';

export const listarCargos = (params = {}) => httpClient.get(base, { params });
export const listarCargosPorMatriculas = (ids) =>
  httpClient.get(base, { params: { matricula_ids: ids.join(','), estado: 'pendiente', pageSize: 50 } });
export const crearCargo = (data) => httpClient.post(base, data);
export const anularCargo = (id) => httpClient.patch(`${base}/${id}/anular`);
